var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7018_43823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 16,
    height: 16,
    transform: "rotate(-90 0 16)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7018_43823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5738 7.99942L6.44628 12.127L5.46875 11.1494L8.61875 7.99942L5.46875 4.84942L6.44628 3.87189L10.5738 7.99942Z",
    fill: "#1D4650"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightSquare);
export default __webpack_public_path__ + "static/media/arrow-right-square.6be156dffe6175adbc6bf0424aa58755.svg";
export { ForwardRef as ReactComponent };